import { ReactComponent as FellowSVG } from "./fellows.svg";
import { SvgIcon } from '@mui/material';

export default function IconFellow(props) {
  return <SvgIcon {...props} component={FellowSVG} viewBox="0 0 25 24" />;
}